/**
 * Public discount tiers hook (PR 8 in the Project Steel rollout).
 *
 * Read-only projection of the admin-managed quantity + order-total
 * discount tables. Drives the `/cenik` page so the discount ladder
 * shown to anonymous visitors stays in sync with what the engine
 * applies during cart/checkout.
 */

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";

export interface PublicQuantityTier {
  /** `null` = the tier applies to every material that doesn't have
   *  its own override (the "global default" lane). */
  material_code: string | null;
  min_qty: number;
  max_qty: number | null;
  discount_pct: number;
}


interface PublicDiscounts {
  quantity_tiers: PublicQuantityTier[];
}

const KEY = ["public-discounts"] as const;

export function usePublicDiscounts(
  options?: Omit<UseQueryOptions<PublicDiscounts>, "queryKey" | "queryFn">,
) {
  return useQuery<PublicDiscounts>({
    queryKey: KEY,
    queryFn: () => apiFetch<PublicDiscounts>("/api/v1/public/discounts"),
    // Match the BE Cache-Control header (10 min).
    staleTime: 10 * 60 * 1000,
    ...options,
  });
}
